<template>
  <div v-if="displayExperienceComponent" class="candidate-experiences">
    <ExtraTipbox v-if="displayBanner" class="q-my-md">{{ $t("ETAB.PAGES.EXTRA.@EXTRA_DOESNT_HAVE_THIS_EXPERIENCE") }}</ExtraTipbox>
    <div class="candidate-experiences-title">{{ $t("ETAB.PAGES.EXTRA.@EXPERIENCES_TITLE") }}</div>
    <!-- Base experience -->
    <BaseExperienceComponent v-if="experiences.base_xp" :xp="experiences.base_xp" />

    <!-- Upper experiences -->
    <template v-if="experiences.upper_xp && experiences.upper_xp.length">
      <BaseExperienceComponent v-for="(expGroup, index) in experiences.upper_xp" :key="'upper-' + index" :xp="expGroup" />
    </template>

    <!-- Lower experiences -->
    <template v-if="experiences.lower_xp && experiences.lower_xp.length">
      <BaseExperienceComponent v-for="(expGroup, index) in experiences.lower_xp" :key="'lower-' + index" :xp="expGroup" />
    </template>

    <!-- Other experiences -->
    <template v-if="experiences.other_xp && experiences.other_xp.length">
      <BaseOtherExperienceComponent :experiences="experiences.other_xp" />
    </template>
  </div>
</template>

<script setup>
  import { computed, defineProps } from "vue";
  import BaseExperienceComponent from "./BaseExperience.component.vue";
  import BaseOtherExperienceComponent from "./BaseOtherExperience.component.vue";
  const props = defineProps({
    experiences: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "",
    },
  });
  const displayExperienceComponent = computed(() => {
    return (
      props.experiences.base_xp ||
      props.experiences.upper_xp.length > 0 ||
      props.experiences.lower_xp.length > 0 ||
      props.experiences.other_xp.length > 0
    );
  });
  const displayBanner = computed(() => {
    return (
      !props.experiences.base_xp &&
      props.experiences.upper_xp.length === 0 &&
      props.experiences.lower_xp.length === 0 &&
      props.experiences.other_xp.length > 0
    );
  });
</script>

<style lang="scss">
  .candidate-experiences {
    &-title {
      font-size: 22px;
      font-weight: 600;
      margin-left: 5px;
      margin-bottom: 5px;
      margin-top: 16px;
    }
  }
</style>
